import { Avatar } from "@repo/ui/avatar";
import classNames from "classnames";
import React from "react";
import { Patient } from "src/lib/definitions";
import { extractAvatarVariant } from "src/lib/utils/avatar-utils";

interface PatientSelectorProps {
  patients: Patient[];
  selectedPatient: Patient;
  onSelectPatient: (patient: Patient) => void;
  className?: string;
}

const PatientSelector: React.FC<PatientSelectorProps> = ({
  patients,
  selectedPatient,
  onSelectPatient,
  className,
}) => {
  return (
    <div
      className={classNames(
        "flex max-w-full justify-center-safe gap-3 min-w-0 overflow-x-auto",
        className
      )}
      role="radiogroup"
    >
      {patients.map((patient) => (
        <label
          key={patient.firstName}
          className="flex flex-col items-center align-center cursor-pointer min-w-[64px] max-w-[120px] flex-1"
        >
          <input
            type="radio"
            name="selectedPatientId"
            value={patient.id}
            checked={selectedPatient.firstName === patient.firstName}
            onChange={() => onSelectPatient(patient)}
            className="sr-only"
            aria-label={`Select ${patient.firstName}`}
          />
          <Avatar
            variant={extractAvatarVariant(
              patient.custom?.profileImage,
              patient.id
            )}
            size="medium"
            isSelected={selectedPatient.id === patient.id}
            className="flex-shrink-0"
          />
          <span
            className={classNames(
              "text-xs font-['Rubik'] leading-none tracking-[0.1px] text-center mt-[8px] h-[16px] truncate w-full select-none",
              selectedPatient.id === patient.id
                ? "text-neutral-800 font-bold"
                : "text-gray-500/60 font-normal"
            )}
          >
            {patient.firstName}
          </span>
        </label>
      ))}
    </div>
  );
};

export default PatientSelector;
